// convert full name to first name + initial
// for example: "John Doe" -> "John D."

export function getFirstNameInitial(fullName = '') {
    if (!fullName) {
        return '';
    }

    const names = fullName.trim().split(' ');
    if (names.length === 1) {
        return names[0];
    }

    const firstName = names[0];
    const lastNameInitial = names.at(-1).charAt(0).toUpperCase();

    return `${firstName} ${lastNameInitial}.`;
}
